export const SET_IDENTITY = 'SET_IDENTITY';
// // export interface Identity {
// //   name: string
// //   // message: string
// //   // timestamp: number
// // }
// // export interface IdentityState {
// //   messages: Message[]
// // }
// // export const SET_IDENTITY = 'SET_IDENTITY'
// // // export const DELETE_MESSAGE = 'DELETE_MESSAGE'
// // interface SendIdentityAction {
// // type: typeof SET_IDENTITY
// // payload: Identity
// // }
// // // interface DeleteMessageAction {
// // //   type: typeof DELETE_MESSAGE
// // //   meta: {
// // //     timestamp: number
// // //   }
// // // }
// // // export type ChatActionTypes = SendMessageAction | DeleteMessageAction
// // export type IdentityActionTypes = SendIdentityAction
